import { render, staticRenderFns } from "./attachment-edit.vue?vue&type=template&id=a850db5c&"
import script from "./attachment-edit.vue?vue&type=script&lang=js&"
export * from "./attachment-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports